import {nameValidator} from '../../../utils';
import {getNextPartnerQuestion} from '../flowPartners/flowPartners';

export const informPartnerName = (inputValue) => nameValidator(inputValue);

export const setPartnerName = (
  ecState,
  partnerSel,
  partnerVd,
  partnerName,
  idQuestion,
  quizPartners,
  partnersTypeList
) => {
  let partners = ecState.partners.map((partner) => {
    if (partner.id === partnerSel.id) {
      return {
        ...partner,
        partnerName: partnerVd.fullname
      };
    }
    return partner;
  });

  let nextQuestion = getNextPartnerQuestion(
    idQuestion,
    quizPartners,
    partners,
    partnerSel,
    partnersTypeList
  );

  let messages = [
    {
      text: partnerVd.fullname,
      type: 'response-sent'
    }
  ];

  messages.push(...nextQuestion.messages);

  return {
    messages,
    partners,
    partnerName,
    nextPartner: nextQuestion.partner,
    changePartner: nextQuestion.nextPartner,
    responseType: nextQuestion.responseTypeChange,
    partnersComplete: nextQuestion.partnersComplete,
    partnersTypeList: nextQuestion.partnersTypeList
  };
};
